import { Component, OnInit,ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ClienteIndividualEntity } from './entities/datos_generales_individual_entity';
import { ClienteLogin, Cliente } from '../../login/cliente_login';
import { correctHeight, detectBody, smoothlyMenu } from "../../../app.helpers";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { ConsultarUsuarioMasivos } from "../../../components/common/utils/consultarUsuarioMasivos";
import { SessionStorageService } from "ngx-webstorage/";

declare var jQuery: any;

@Component({
    templateUrl: 'datos-generales.template.html',
})

export class datosGenerales implements OnInit {
    usuario: ClienteLogin;
    userAUsar: Cliente;
    bandera: boolean;
    maxDateValue: Date;
    minDateValue: Date;
    yearRange: string;

    constructor(private sessionStorageService: SessionStorageService,private handleError: HandleError, private sessionTokenService: SessionTokenService, private consultarMasivo:ConsultarUsuarioMasivos) { 
    }

    ngOnInit(): void {
        this.consultarMasivo.iniciarUsuarioMasivo();
        this.userAUsar = jQuery.parseJSON(this.sessionStorageService.retrieve("usermasivos"));
        if (this.userAUsar.TipoCliente == 1) {
            this.bandera = true;
        } else {
            this.bandera = false;
        }
        this.sessionStorageService.observe("usermasivos").subscribe(v=>{
            this.userAUsar = jQuery.parseJSON(v);
            if (this.userAUsar.TipoCliente == 1) {
                this.bandera = true;
            } else {
                this.bandera = false;
            }
        });
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/datos-generales.component.ts